"use client";

import React, {useState} from "react";
import {PlusIcon, MinusIcon} from "@heroicons/react/24/solid";
import {FaqType} from "@/types/FaqType";
import {AnimatePresence, motion} from "framer-motion";
import ContainerWrapper from "@/components/wrappers/ContainerWrapper";
import {useCompanyInfo} from "@/hooks/useCompanyInfo";

export default function LandingFaq({
                                       faqs,
                                       openAll = false,
                                   }: {
    faqs: FaqType[];
    openAll?: boolean;
}) {
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const {badge_icon} = useCompanyInfo();

    const toggle = (index: number) => {
        if (!openAll) {
            setOpenIndex(openIndex === index ? null : index);
        }
    };

    return (
        <ContainerWrapper>
            <div className="my-12">
                {/*<ContainerWrapper className="container mx-auto px-2 mt-10 mb-12">*/}
                <h2 className="text-xl font-bold mb-10 flex items-center gap-2">
                <span className="text-pink-500 text-xl">
                    {badge_icon && (
                        <img
                            src={badge_icon}
                            alt=""
                            className="size-6"
                        />
                    )}
                </span>
                    <span className="text-lg sm:text-xl">سوالات متداول</span>
                </h2>
                {openAll && (
                    <hr className="h-px m-8 border-yellow-500/30 border-2"/>
                )}
                <div className="mx-auto flex flex-col gap-6">
                    {faqs.map((faq, index) => {
                        const isOpen = openAll || openIndex === index;

                        return (
                            <div key={index} className="flex items-start justify-between">
                                <div className="text-right w-full pr-4" onClick={() => toggle(index)}>
                                    <p className="text-sm md:text-base md:font-medium">{faq.question}</p>

                                    <AnimatePresence initial={false}>
                                        {isOpen && (
                                            <motion.p
                                                initial={{opacity: 0, height: 0}}
                                                animate={{opacity: 1, height: "auto"}}
                                                exit={{opacity: 0, height: 0}}
                                                transition={{duration: 0.3, ease: "easeInOut"}}
                                                className="text-sm text-justify text-gray-600 mt-2 overflow-hidden px-4 lg:px-12"
                                            >
                                                {faq.answer}
                                            </motion.p>
                                        )}
                                    </AnimatePresence>
                                </div>

                                {!openAll && (
                                    <button
                                        onClick={() => toggle(index)}
                                        className="bg-black text-white p-1 rounded-md w-6 h-6 flex items-center justify-center mt-1"
                                    >
                                        {openIndex === index ? (
                                            <MinusIcon className="w-4 h-4"/>
                                        ) : (
                                            <PlusIcon className="w-4 h-4"/>
                                        )}
                                    </button>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </ContainerWrapper>
    );
}